import { addValidationRule } from 'formsy-react';
// import { useEffect, useState } from 'react';
import { getNumberFormatSeperator, updateObject } from '../../../common/helper';
import {
  disableTrancheAmountField,
  disableTrancheBankFields,
  FINANCIER_DECIMAL_LIMIT,
  FINANCIER_ID,
  OTHERS_OPTION,
  PAYMENT_TYPE,
  PAYMENT_TYPE_AMOUNT_LABEL,
  PAYMENT_TYPE_LABEL,
  TRANCHE_STATUS as TRANCHE_STATUSS,
  FINSSO_BANK_DETAILS,
  IF_FINSSO_BANK_OPTION,
  IF_FINSSO_BANK_DETAILS
} from '../../../config/constants';
import checkIcon from '../../../webroot/images/icon.svg';
import FormsyCheckBox from '../../elements/FormsyCheckBox';
import FormsyInputField from '../../elements/FormsyInputField';
import FormsySelect from '../../elements/FormsySelect';
import payment_verification_fields from '.././formFields/paymentVerification.json';
import { useSelector } from 'react-redux';
const SPLIT_PAYMENT_FIELDS = payment_verification_fields?.split_payment_details_v2 || [];
const CUSTOM_OPTION = {id:0,label:"Custom",value:"custom"};

const TRANCHE_STATUS = {
  "paid": "Paid",
  "on_hold": "On Hold",
  "requested": "Requested"
}

const SplitPaymentFormTwo = (props) => {
  const {
    getContext,
    bankOptions,
    splitBankOptions,
  } = props;
  const {leadDocs } = useSelector(({ lead }) => ({
      leadDocs: (lead && (lead.leadDetail && (lead.leadDetail.leaddocs || [])))
    }));
  addValidationRule('isValidAccountNumber', function(values, value) {
    const accountNumbers = splitPaymentDetails.reduce((result, details) => { if([PAYMENT_TYPE.SplitDealer, PAYMENT_TYPE.SplitDealer2].includes(details?.payment_type) && details.account_number) result.push(details.account_number); return result; }, []);
    let bank_acc_number_match =  accountNumbers.some((accountNumber, index) => {
      return accountNumbers.indexOf(accountNumber) !== index;
    });

    if(bank_acc_number_match)
      return "Account number of all split payment must be different";
    else
      return true;
  });

  let { split_trance,
    setPaymentVerificationDetails,
    splitPaymentDetails, setSplitPaymentDetails,
    index, financierId, leadDetail, handleCheckboxChange
  } = props;

  const handleInputChange = (target_id, event, type, payment_type, index) => {
    let value = type === "number-format" ? event.floatValue : type === 'dropdown' ? event.value : event.target.value;
    let updatedSplitPayment = [...splitPaymentDetails];
    if (target_id) {
        if(payment_type === "mandatory_fields"){
            setPaymentVerificationDetails(currentValue => ({
                ...currentValue,
                [target_id]: value
            }))
        }else if(payment_type === "split_payment" && index != null){
            if(target_id === 'bank_account') {
              const matchingDealerBank = [...(leadDetail?.dealerData?.[0]?.bank_details || []), ...(leadDetail?.dealerData?.[1]?.bank_details || [])]?.find(dealer => dealer.account_number === value);
              if (matchingDealerBank) {
                updatedSplitPayment[index][target_id] = value;
                updateObject(updatedSplitPayment[index], matchingDealerBank || {}, ["bank_name", "branch_name", "account_holder_name", "account_number", "dealer_id", "is_bank_verified"]);
              }
              const isOnholdTrachPresent = splitPaymentDetails?.find(item => item?.payment_type === PAYMENT_TYPE.OnHoldDealer);
              if (isOnholdTrachPresent && PAYMENT_TYPE.MainDealer === splitPaymentDetails?.[index]?.payment_type) {
                updateObject(isOnholdTrachPresent, { ...updatedSplitPayment[0] }, ["bank_name", "branch_name", "account_holder_name", "account_number", "dealer_id", "is_bank_verified"]);
                isOnholdTrachPresent[target_id] = value;
              }
              if(FINSSO_BANK_DETAILS.account_number === value) {
                updatedSplitPayment[index] = {
                  ...updatedSplitPayment[index],
                  [target_id]: value,
                  "bank_name": FINSSO_BANK_DETAILS.bank_name,
                  "branch_name": FINSSO_BANK_DETAILS.branch_name,
                  "account_holder_name": FINSSO_BANK_DETAILS.account_holder_name,
                  "account_number": FINSSO_BANK_DETAILS.account_number,
                  "bank_account": FINSSO_BANK_DETAILS.account_number,              
                }
              }
              if(IF_FINSSO_BANK_DETAILS.account_number === value) {
                updatedSplitPayment[index] = {
                  ...updatedSplitPayment[index],
                  [target_id]: value,
                  "bank_name": IF_FINSSO_BANK_DETAILS.bank_name,
                  "branch_name": IF_FINSSO_BANK_DETAILS.branch_name,
                  "account_holder_name": IF_FINSSO_BANK_DETAILS.account_holder_name,
                  "account_number": IF_FINSSO_BANK_DETAILS.account_number,
                  "bank_account": IF_FINSSO_BANK_DETAILS.account_number,              
                }
              }
              if(value === 'custom') {
                updatedSplitPayment[index] = {
                  ...updatedSplitPayment[index],
                  [target_id]: value,
                  bank_name: '',
                  branch_name: '',
                  account_holder_name: '',
                  account_number: ''
                }
              }
            }
            else if (target_id === "bank_name_id") {
              updatedSplitPayment[index] = { ...updatedSplitPayment[index], [target_id]: event?.value };
              updatedSplitPayment[index] = { ...updatedSplitPayment[index], "bank_name": event?.value !== OTHERS_OPTION?.value ? event?.label : "" };
            }
            else if(target_id === "amount_to_be_paid")
              updatedSplitPayment[index] = {...updatedSplitPayment[index], [target_id]: event?.target?.value ? parseFloat(event?.target?.value.replace(/,/g, '')) : 0}
            else
              updatedSplitPayment[index] = {...updatedSplitPayment[index], [target_id]: value}
            setSplitPaymentDetails([...updatedSplitPayment]);
        }
    }
}

let isPaymentProofUploaded = {
    main_dealer: leadDocs?.find(doc => doc?.doc_id === 177)?.doc_path ? true : false,
    onhold_dealer: leadDocs?.find(doc => doc?.doc_id === 177)?.doc_path ? true : false,
    split_dealer: leadDocs?.find(doc => doc?.doc_id === 178)?.doc_path ? true : false,
    split_dealer2: leadDocs?.find(doc => doc?.doc_id === 178)?.doc_path ? true : false,
    if_settlement: true
  };
  
  const isCheckboxChecked = () => {
    const isChecked = ['paid', 'requested'].includes(splitPaymentDetails?.[index]?.tranche_status) || splitPaymentDetails?.[index]?.is_tranche_marked;
    if (isChecked === undefined) return false;
    return isChecked;
  };

  let selectCondition = (leadDetail?.is_pushed_to_pb === "1" && !splitPaymentDetails?.[index]?.is_tranche_marked) || false;

  const currentAmount = Number(splitPaymentDetails?.[index]?.amount || 0);
  const isZeroAmount = currentAmount === 0 && splitPaymentDetails?.[index]?.payment_type !== PAYMENT_TYPE.SplitDealer2;
  const isDocMissing = !isPaymentProofUploaded[splitPaymentDetails?.[index]?.payment_type];
    return (
        <div className="row"> 
        { 
            <div className="col-md-12">
              <div className='split-act-btn'> 
              <FormsyCheckBox
                id="tranch_checkbox"
                name={`tranch_checkbox_${splitPaymentDetails?.[index]?.payment_type}`}
                type="checkbox"
                className="custom-control-input"
                value="1"
                checked={isCheckboxChecked()}
                title={
                  isZeroAmount
                    ? "Cannot select tranche with amount 0. It will auto-select with IF tranche."
                    : isDocMissing
                    ? "Upload Proof of Payment received document for this tranche to proceed."
                    : ""
                }
                onChange={(e) => handleCheckboxChange(e,index)}
                disabled={getContext.markAsFreezed || (leadDetail?.is_pushed_to_pb==="1" && ['requested','paid'].includes(leadDetail?.split_payment?.find(split => split.payment_type === splitPaymentDetails[index]?.payment_type)?.tranche_status)) || isDocMissing || isZeroAmount}
              />
                <h3>{ PAYMENT_TYPE_LABEL?.[splitPaymentDetails?.[index]?.payment_type]}</h3>
                <span className={splitPaymentDetails?.[index]?.tranche_status ? 'btn-primary-accent history-btn tranche-status' : ''}>{TRANCHE_STATUS[split_trance?.tranche_status]}</span>
              </div>
            </div>
        }
        {SPLIT_PAYMENT_FIELDS?.map((field) => {
          return ((field?.dependentOn && field?.dependentValue.includes(splitPaymentDetails[index]?.[field?.dependentOn])) || !field?.dependentOn) && ( ["text", "pattern-format", "number-format"].includes(field?.type) ? 
          <fieldset class="form-filed col-md-6 ">
              <FormsyInputField
                id={"split_"+field?.id}
                name={field?.name}
                type={field?.type}
                value={["amount_to_be_paid"].includes(field?.name) ? (splitPaymentDetails?.[index]?.is_tranche_marked_for_recovery ? (splitPaymentDetails?.[index]?.[field?.name] || 0): splitPaymentDetails?.[index]?.amount) : (splitPaymentDetails?.[index]?.[field?.name] || "")}
                placeholder=" "
                {...getNumberFormatSeperator(field?.type)}
                label={(field?.name === "amount_to_be_paid" && PAYMENT_TYPE_AMOUNT_LABEL[splitPaymentDetails?.[index]?.payment_type]) || field?.label}
                onChange={(e) => handleInputChange(field?.id, e, field?.type, "split_payment", index)}
                format={field?.ApplyNumberformat ? field?.format : ""}
                validationError={field?.validationError}
                required={isCheckboxChecked() || ([PAYMENT_TYPE.MainDealer, PAYMENT_TYPE.OnHoldDealer].includes(splitPaymentDetails?.[index]?.payment_type)) || (field?.name === 'amount_to_be_paid' && [PAYMENT_TYPE.SplitDealer, PAYMENT_TYPE.SplitDealer2].includes(splitPaymentDetails?.[index]?.payment_type))}
                disabled={
                  getContext.markAsFreezed
                  || selectCondition
                  || (field?.name === "bank_name" && splitPaymentDetails[index]["bank_account"] === CUSTOM_OPTION?.value && splitPaymentDetails[index]["bank_name_id"] !== OTHERS_OPTION?.value)
                  || ["requested", "paid"].includes(splitPaymentDetails[index]?.tranche_status)
                  || (index === 0 && splitPaymentDetails?.[index]?.bank_account !== CUSTOM_OPTION?.value && leadDetail?.dealerData?.[0]?.[field?.name] !== null)
                  || (field?.name === "amount_to_be_paid" && disableTrancheAmountField?.[splitPaymentDetails[index]?.payment_type])
                  || (splitPaymentDetails[index]?.bank_account !== 'custom' && disableTrancheBankFields?.[field?.name])
                  || (splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.IfSettlementTranche && field.name === 'amount_to_be_paid')
                }
                isVerified={field?.name === "account_number" && splitPaymentDetails?.[index]?.is_bank_verified === '1'}
                decimalScale={(Number(financierId) === FINANCIER_ID.JACCS_FINANCE && FINANCIER_DECIMAL_LIMIT.JACCS_FINANCE) || FINANCIER_DECIMAL_LIMIT.DEFAULT}
              />
          </fieldset>
           :
            field?.type === "dropdown" ? 
              <fieldset class="single-select col-md-6">
                <FormsySelect
                  name={field.name}
                  id={field.id}
                  inputProps={{
                    options:
                    splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.IfSettlementTranche
                    ? [IF_FINSSO_BANK_OPTION]
                    : leadDetail?.lead_computation_details?.finsso_transfer === "Yes" && splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.MainDealer
                      ? (() => {
                          return bankOptions?.slice(-1); // only last option for Finsso + MainDealer
                        })()
                      : ([PAYMENT_TYPE.SplitDealer, PAYMENT_TYPE.SplitDealer2].includes(
                          splitPaymentDetails?.[index]?.payment_type
                        ))
                      ? (() => {
                          const currentType = splitPaymentDetails?.[index]?.payment_type;
                          const shouldSlice = ((currentType === PAYMENT_TYPE.SplitDealer || PAYMENT_TYPE.SplitDealer2) && leadDetail?.lead_computation_details?.finsso_transfer === "Yes");
                          const filteredOptions = [...splitBankOptions]
                            .slice(0, shouldSlice ? -1 : undefined)
                            ?.filter((data) =>
                              splitPaymentDetails
                                ?.filter((item) =>
                                  [PAYMENT_TYPE.SplitDealer, PAYMENT_TYPE.SplitDealer2].includes(
                                    item?.payment_type
                                  )
                                )
                                ?.every(
                                  (split) =>
                                    split.account_number !== data.value ||
                                    split?.payment_type === splitPaymentDetails?.[index]?.payment_type
                                )
                            );
                          return filteredOptions;
                        })()
                      : (() => {
                          return bankOptions;
                        })(),
                    placeholder: field.label,
                    className: "react-select",
                    classNamePrefix: "react-select",
                    formatOptionLabel: (data, { context }) => (
                      context === 'value' 
                        ? data.label 
                        : (
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            {data.label}
                            {data.is_bank_verified === '1' && <img src={checkIcon} style={{ width: '15px', height: '15px' }} alt="verified" />}
                          </span>
                        )
                    ),
                    value:
                    splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.IfSettlementTranche
                                          ? IF_FINSSO_BANK_OPTION:
                      leadDetail?.lead_computation_details?.finsso_transfer === "Yes" && splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.MainDealer
                        ? bankOptions?.slice(-1)
                        : [
                            ...bankOptions,
                                ...splitBankOptions,
                            ...(
                              [TRANCHE_STATUSS.requested, TRANCHE_STATUSS.paid].includes(
                                splitPaymentDetails?.[index]?.tranche_status
                              )
                                ? [CUSTOM_OPTION]
                                : []
                            ),
                          ].filter(({ value }) =>
                            splitPaymentDetails?.[index]?.bank_account?.includes(value)
                          ),
                    isDisabled:
                    splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.IfSettlementTranche
                     ? true
                      : (leadDetail?.lead_computation_details?.finsso_transfer === "Yes" && splitPaymentDetails?.[index]?.payment_type === PAYMENT_TYPE.MainDealer) ||
                      getContext.markAsFreezed ||
                      (['requested', 'paid'].includes(
                        leadDetail?.split_payment?.find(
                          (split) =>
                            split.payment_type === splitPaymentDetails?.[index]?.payment_type
                        )?.tranche_status
                      ) ||
                        selectCondition) ||
                      ([PAYMENT_TYPE.OnHoldDealer].includes(
                        splitPaymentDetails?.[index]?.payment_type
                      ) && leadDetail?.lead_computation_details?.finsso_transfer === "No"),
                  }}
                  value={splitPaymentDetails[index]?.[field?.name]}
                  onChange={(e) => handleInputChange(field.id, e, field.type, "split_payment", index)}
                  required={
                    isCheckboxChecked() ||
                    [PAYMENT_TYPE.MainDealer].includes(splitPaymentDetails?.[index]?.payment_type)
                  }
                />

              </fieldset>
            : <></>
        )})}
        
      </div>
    );
}
export default SplitPaymentFormTwo;